var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',_vm._g(_vm._b({attrs:{"variant":"warning"}},'b-badge',_vm.$attrs,false),_vm.$listeners),[_c('i',{staticClass:"far fa-clock mr-1"}),_vm._v(" Em breve\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }